import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {TabComponent} from './tab.component';

@Component({
  selector: 'app-tabs',
  template: `
    <div class="tabs-container">
      <ul class="nav-tabs" [ngClass]="{'has-underline': hasUnderline}" [style]="{'padding-left': tabsMarginLeft}">
        <li *ngFor="let tab of tabs" class="tab"
            [ngClass]="{'active': tab.active === true }"
            (click)="selectTab(tab)"
        >
          <div *ngIf="tab.tabTitle" class="title">{{ tab.tabTitle }}</div>
          <div *ngIf="tab.tabTitleHTML" [innerHTML]="tab.tabTitleHTML" class="title-html"></div>
          <span *ngIf="tab.hasCount" class="count">{{tab.count}}</span>
        </li>
      </ul>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements AfterContentInit {
  @Input() tabsMarginLeft = '0px';
  @Input() hasUnderline: boolean;

  @Output() tabSelected: EventEmitter<any> = new EventEmitter();

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  ngAfterContentInit(): void {
    if (!this.tabs.toArray().some(tab => tab.active)) {
      this.tabs.first.active = true;
    }
  }

  selectTab(tab: TabComponent): void {
      if (!tab.active) {
        this.tabs.toArray().forEach((child: TabComponent) => child.active = false);
        this.tabSelected.emit(tab.tabValue !== undefined ? tab.tabValue : tab.tabTitle);
        tab.active = true;
      }
    }
}
